import React from 'react';
import styled from 'styled-components';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import Modal from '@components/Modal';
import SimpleButton, { COLOR, SIZE } from '@components/SimpleButton';
import messages from './messages';

const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  padding: ${({ theme }) => theme.commons.modal.spaces};
`;

const Title = styled.div`
  ${({ theme }) => theme.fontFamily.mainFont.xLargeExtraBold}
  align-self: center;
  width: 100%;
`;

const Subtitle = styled.div`
  ${({ theme }) => theme.fontFamily.secondaryFont.smallRegular}
  align-self: center;
  line-height: ${({ theme }) => theme.spaces.space_18};
  width: 100%;
  margin: ${({ theme }) => theme.spacing(2, 0, 12, 0)};
`;

const Footer = styled.div`
  width: 100%;
`;

function ModalInfo({
  isLogisticsDelivery,
  formatMessage,
  message,
  showModal,
  onClose,
}) {
  const title = isLogisticsDelivery
    ? formatMessage(messages.withLogistics)
    : formatMessage(messages.ownDelivery);

  return (
    <Modal open={showModal} onClose={onClose} hideOptions>
      <Container>
        <Title>{title}</Title>
        <Subtitle>{message}</Subtitle>
        <Footer>
          <SimpleButton
            label={formatMessage(messages.close)}
            color={COLOR.PRIMARY}
            size={SIZE.MEDIUM}
            onClick={onClose}
          />
        </Footer>
      </Container>
    </Modal>
  );
}

ModalInfo.propTypes = {
  message: PropTypes.string.isRequired,
  showModal: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  isLogisticsDelivery: PropTypes.bool,
  formatMessage: PropTypes.func,
};

export default injectIntl(ModalInfo);
